import { Box, ListItem, ListItemIcon, ListItemText } from "@mui/material"
import { ReactNode, useEffect, useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { NavItem } from "../../interfaces/userContext";
import * as labels from "../../constants/navigation";


export interface IListItemProps {
    onClick?: () => any,
    iconName?: string,
    label: string,
    expanded?: boolean,
    children?: ReactNode,
    collapsed?: boolean,
    hasChildren?: boolean,
    onToggle?: (order?: string) => any,
    parent?: NavItem;
    className?: string;
    open?: boolean,
    iconElement?: ReactNode
    activePath?: string
}

export const getIcon = (iconName?: string): string | null => {
    if (iconName) {
        try {
            // TODO: Replace assets/sdc_inbound.svg with the final SDC Inbound icon once design is finalized.
            return require(`../../assets/${iconName}.svg`).default;
        } catch (err) {
            return '';
        }
    }
    return null;
};

export const RenderNavListItemIcon = ({ icon, elem }: { icon?: string, elem: ReactNode }) => {
    return (
        <ListItemIcon className="nav-child-item-icon">
            {elem}
            {icon && (
                <img
                    src={getIcon(icon) || ''}
                    alt={icon}
                    className="nav-icon"
                />
            )}
        </ListItemIcon>)
}

const NavListItem = (props: IListItemProps) => {
    const { onClick, iconName, iconElement, open, label, expanded, collapsed, hasChildren, onToggle, parent, activePath } = props
    const [isActive, setIsActive] = useState(false)
    const handleChildExpansion = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
        onToggle ? onToggle(parent?.order) : null;
    }



    useEffect(() => {
        const isLinkActive = activePath ? (location.pathname.endsWith(activePath.toLowerCase().replace(/\s+/g, '-'))) : false;
        setIsActive(hasChildren ? isActive : isLinkActive)
    }, [location.pathname])

    const isActiveClass = isActive ? 'is-active' : '';
    const labelInUpperCaseLookup = `${label.toUpperCase().replaceAll(' ', '_')}_NAV_LABEL`;
    const itemLabel = labels[labelInUpperCaseLookup as keyof typeof labels] || label;
    return (
        <ListItem
            component="div"
            key={`vision-nav-item-${label}`}
            className={`nav-child-item ${isActiveClass}`}
            onClick={onClick}
        >
            <RenderNavListItemIcon icon={iconName} elem={iconElement} />
            <ListItemText primary={itemLabel} />
            {!collapsed && hasChildren && (
                <Box onClick={handleChildExpansion} className={`nav-box-arrow ${isActiveClass}`} >
                    {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </Box>
            )}
        </ListItem>)
}

export default NavListItem;